<template>
  <md-menu
    :md-active.sync="isCardOpen"
    class="lang-switcher"
    md-align-trigger
    md-size="huge"
    md-direction="bottom-end"
    data-test-id="lang-switcher"
  >
    <md-button
      md-menu-trigger
      :md-ripple="false"
      class="lang-switcher__current"
      data-test-id="lang-switcher-btn"
    >
      <md-icon
        md-src="/static/img/globe.svg"
        data-test-id="lang-switcher-btn-icon"
      ></md-icon>
      <span data-test-id="lang-switcher-current-lang">
        {{ getUserLocale }}
      </span>
    </md-button>

    <md-menu-content
      class="lang-switcher__options redesign-menu"
      data-test-id="lang-switcher-list-container"
    >
      <md-menu-item
        v-for="(locale, idx) in locales"
        :key="idx"
        class="lang-switcher__options-item"
        :data-test-id="`lang-switcher-list-item-${locale}`"
      >
        <button
          :data-test-id="`lang-switcher-list-item-${locale}-btn`"
          @click="setLocale(locale)"
        >
          {{ locale }}
        </button>
      </md-menu-item>
    </md-menu-content>
  </md-menu>
</template>

<script>
import { vuexTypes } from '@vuex/types'
import { mapGetters, mapActions } from 'vuex'
import { setLangAskReload, langByCookie, getCookie, setCookie } from '@js/i18n'

export default {
  name: 'LangSwitcher',

  components: { },
  data: () => ({
    isCardOpen: false
  }),
  computed: {
    ...mapGetters({
      getUserLocale: vuexTypes.getUserLocale
    }),
    locales () {
      return ['en', 'ua', 'ru'].filter(locale => locale !== this.getUserLocale)
    }
  },
  methods: {
    ...mapActions({
      GET_USER_LOCALE: vuexTypes.GET_USER_LOCALE,
      SET_USER_LOCALE: vuexTypes.SET_USER_LOCALE
    }),
    delay (ms) {
      return new Promise(resolve => setTimeout(resolve, ms))
    },
    setLocale (name) {
      this.SET_USER_LOCALE(name)
      this.isCardOpen = false
      this.delay(250).then(() => setLangAskReload(name)) // FIXME fix this hack
    },
    initLocale (name) {
      if (getCookie('redirectLang')) {
        this.SET_USER_LOCALE(langByCookie())
        setCookie('redirectLang', '', -1)
      } else {
        if (name === '') {
          this.SET_USER_LOCALE(langByCookie())
          return
        }
        if (langByCookie() !== name) {
          setLangAskReload(name)
        }
      }
    }
  },

  async created () {
    await this.initLocale(this.getUserLocale)
  }
}
</script>

<style scoped lang="scss">
@import "../../scss/variables";

.lang-switcher {
  position: relative;

  &__current {
    display: flex;
    align-items: center;
    cursor: pointer;
    gap: 1rem;
    text-transform: uppercase;
    color: $default-white;
    font-size: 20px;
    font-weight: normal;

    &.md-button {
      min-width: max-content !important;

      &:before {
        content: none;
      }

      /deep/ .md-ripple {
        padding: 0;
      }

      /deep/ .md-button-content {
        display: flex;
        align-items: center;
        justify-content: space-between;
      }

      .md-icon {
        margin-right: 12px;
      }
    }
  }

  &__options {
    min-width: 100px;
    max-width: 100px;
    width: 100%;

    .md-list {
      .md-list-item:not(:nth-child(1)) {
        padding-bottom: 0px !important;

        &:before {
          content: '';
          position: absolute;
          top: 0;
          left: 16px;
          width: calc(100% - 32px);
          height: 1px;
          background-color: rgba(0,0,0,.2);
        }
      }
    }

    &-item {
      /deep/ .md-list-item-content {
        padding-top: 0px;
        padding-bottom: 0px;
        min-height: 40px;
      }

      button {
        border: none;
        text-transform: uppercase;
        background: transparent;
        cursor: pointer;
        width: 100%;
        height: 100%;
        padding: 0rem;
        display: flex;
        justify-content: center;
        font-size: 20px;
        font-weight: 400;
        padding: 0.5rem 0;
        transition: background 0.2s ease-in;

        &:hover {
          background-color: $light-grey;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/vue/navigation/LangSwitcher.vue